export default __webpack_public_path__ + "e5c85a21162eecfc2e2ded0763ed5405.twig";